import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {GetAnalyticsRequest} from '../models/analytics/analytics.request';
import {GetAnalyticsResponse} from '../models/analytics/analytics.response';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private ANALYTICS_URL: string = environment.BASE_URL + 'analytics';

  constructor(private http: HttpClient) {
  }

  public getAnalytics(request: GetAnalyticsRequest): Observable<GetAnalyticsResponse> {
    return this.http.post<GetAnalyticsResponse>(`${this.ANALYTICS_URL}`, request);
  }
}
